import { render, staticRenderFns } from "./BaseTLModalDialogTable.vue?vue&type=template&id=5080a460&"
import script from "./BaseTLModalDialogTable.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports